<div class="loader-wrapper loaded">
  <div class="loader-div">
    <!-- rounded loader -->
    <div class="star-wraper">
      <div class="loader">
        <div class="loader-inner line-spin-fade-loader">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div class="star star1">
        <img
          src="/assets/icon/loader-star.svg"
          alt=" Lowest Coverage"
          width="24"
          hwight="24"
          class="details-icon"
        />
      </div>
      <div class="star star2">
        <img
          src="/assets/icon/loader-star.svg"
          alt=" Lowest Coverage"
          width="16"
          hwight="16"
          class="details-icon"
        />
      </div>
      <div class="star star3">
        <img
          src="/assets/icon/loader-star.svg"
          alt=" Lowest Coverage"
          width="28"
          hwight="28"
          class="details-icon"
        />
      </div>
    </div>
    <!-- question section -->
    <div class="question-wrapper">
      <p *ngIf="progressbarValue < 20">
        Hang tight… we’re contacting a bunch of insurance companies…
      </p>
      <p *ngIf="progressbarValue >= 20 && progressbarValue < 40">
        Getting there… we’re talking to the insurance companies about your quote…
      </p>
      <p *ngIf="progressbarValue >= 40 && progressbarValue < 60">
        So, so close… they are crunching the numbers now…
      </p>
      <p *ngIf="progressbarValue >= 60 && progressbarValue < 80">
        Can’t wait to show you what we have!
      </p>
      <p *ngIf="progressbarValue >= 80">
        Fine-tuning the quotes… we’re almost there…
      </p>
    </div>
    <!-- progress bar -->
    <div class="progressBar-wrapper">
      <div class="meter">
        <span [style.width]="progressbarValue + '%'"></span>
      </div>
    </div>
    <div class="basic-container"></div>
  </div>
</div>
